import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/refund/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/refund/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/refund/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/refund/delete/${id}`)
}
